<template>
  <div v-if="isBlocked" class="site-lock">
    <CardSurface raised pad="lg" class="site-lock__card">
      <p class="site-lock__eyebrow mb-2">Preview access</p>
      <h1 class="site-lock__title mb-3">Enter password</h1>
      <p class="site-lock__lead mb-4">This site is password-protected in production builds.</p>
      <form class="site-lock__form" @submit.prevent="handleSubmit">
        <label for="site-lock-password" class="site-lock__label">Password</label>
        <input
          id="site-lock-password"
          v-model="password"
          type="password"
          class="site-lock__input"
          placeholder="Password"
          autocomplete="current-password"
          autofocus
        />
        <p v-if="error" class="site-lock__error" role="alert">{{ error }}</p>
        <button type="submit" class="nm-btn nm-btn--primary w-100 mt-3">
          <i class="fa-solid fa-lock-open" aria-hidden="true" />
          Unlock
        </button>
      </form>
    </CardSurface>
  </div>
  <slot v-else />
</template>

<script setup>
import { ref } from 'vue'
import CardSurface from '@/components/CardSurface.vue'
import { useSiteLock } from '@/composables/useSiteLock'

const { isBlocked, tryUnlock, error } = useSiteLock()
const password = ref('')

function handleSubmit() {
  tryUnlock(password.value.trim())
}
</script>

<style scoped>
.site-lock {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background:
    radial-gradient(ellipse at 50% 0%, rgba(150, 146, 196, 0.35) 0%, transparent 55%),
    linear-gradient(180deg, var(--nm-bg-top) 0%, var(--nm-bg-mid) 38%, var(--nm-bg-base) 72%, var(--nm-bg-abyss) 100%);
}

.site-lock__card {
  width: 100%;
  max-width: 22rem;
  text-align: center;
}

.site-lock__eyebrow {
  font-size: 0.72rem;
  font-weight: var(--nm-font-weight-semibold);
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--nm-accent);
}

.site-lock__title {
  font-size: 1.35rem;
  font-weight: var(--nm-font-weight-semibold);
}

.site-lock__lead {
  font-size: 0.9rem;
  color: var(--nm-text-muted);
  line-height: 1.6;
}

.site-lock__label {
  display: block;
  text-align: left;
  font-size: 0.78rem;
  font-weight: var(--nm-font-weight-semibold);
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--nm-text-secondary);
  margin-bottom: 0.5rem;
}

.site-lock__input {
  width: 100%;
  padding: 0.85rem 1rem;
  border-radius: var(--nm-radius-md);
  border: 1px solid rgba(255, 255, 255, 0.06);
  background: var(--nm-surface-inset);
  box-shadow: var(--nm-inset-sm);
  color: var(--nm-text-primary);
  font-family: var(--nm-font);
  font-size: 0.95rem;
}

.site-lock__error {
  font-size: 0.82rem;
  color: var(--nm-danger);
  margin: 0.5rem 0 0;
  text-align: left;
}
</style>